module.exports = __webpack_public_path__ + "static/media/face-3.ce7a6b79.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/faces/face-3.jpg
// module id = ./src/assets/images/faces/face-3.jpg
// module chunks = 0